module.exports = __webpack_public_path__ + "static/media/heroBack.f40fc190.svg";